import styled from 'styled-components'
import { COLOURS } from 'resources'
import { ReactComponent as checkMarkIcon } from 'resources/images/icons/checkmark-purple.svg'
import { ReactComponent as editPencil } from 'resources/images/icons/edit-pencil.svg'
import { ReactComponent as fileIcon } from 'resources/images/icons/file-icon.svg'
import RoundedButton from 'components/RoundedButton'

const statusColors = {
  signed: {
    color: COLOURS.systemGreen,
    backgroundColor: COLOURS.utilitySuccess50,
    borderColor: COLOURS.systemGreen1,
  },
  unsigned: {
    color: COLOURS.systemBrown1,
    backgroundColor: COLOURS.paleYellow,
    borderColor: COLOURS.systemYellow1,
  },
}

export const Container = styled.div`
  margin-top: 40px;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${COLOURS.neutralGrey1};
`

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

export const SignStatusPill = styled.div`
  display: flex;
  color: ${({ status }) => statusColors[status].color};
  background-color: ${({ status }) => statusColors[status].backgroundColor};
  border-radius: 20px;
  border: 1px solid ${({ status }) => statusColors[status].borderColor};
  font-size: 14px;
  line-height: 14px;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 10px;
  margin-bottom: 15px;
`

export const CheckIcon = styled(checkMarkIcon)`
  margin-right: 2px;
  width: 14px;
  height: 14px;

  path {
    fill: ${COLOURS.systemGreen} !important;
  }
`

export const EditIcon = styled(editPencil)`
  margin-right: 2px;
  width: 14px;
  height: 14px;

  path {
    fill: ${COLOURS.systemBrown1} !important;
  }
`

export const FileIcon = styled(fileIcon)`
  width: 48px;
  height: 48px;
  padding: 10px;
  background-color: ${COLOURS.neutralGrey2};
  border-radius: 8px;
  path {
    fill: ${COLOURS.darkGrey2};
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Subtitle = styled.div`
  font-family: 'EBGaramond', sans-serif;
  font-size: 14px;
  color: ${COLOURS.darkGrey3};
  margin-bottom: 5px;
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 36px;
  line-height: 36px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`

export const ArrowButton = styled(RoundedButton).attrs({
  withArrow: true,
  variant: 'secondaryPurple',
})`
  width: 100%;
  border-radius: 4px;

  &.with-arrow {
    justify-content: center;
  }

  &.with-arrow .arrow {
    width: 20px;
  }

  &.arrow {
    width: 20px;
  }
`

export const VoidButton = styled(RoundedButton).attrs({
  variant: 'transparentPurple1',
})`
  width: 60%;
  border-radius: 4px;
`

export const InfoMessage = styled.div`
  font-family: 'EBGaramond', sans-serif;
  font-size: 14px;
  color: ${({ colour }) => colour || COLOURS.neutralBlack};
  margin-top: 10px;
`
